import React from 'react';
import { Helmet } from 'react-helmet-async';

export const SEO = ({ title, description, name, type, url, schema, image }) => {
    const fullTitle = title ? `${title} | Keyer's Journey` : "Keyer's Journey | Training, History & Adventure";
    const canonicalURL = url || (typeof window !== 'undefined' ? window.location.href : "https://keyersjourney.com");
    const siteImage = image || "https://www.keyersjourney.com/icon.png";

    return (
        <Helmet>
            {/* Standard metadata tags */}
            <title>{fullTitle}</title>
            <meta name='description' content={description} />
            <link rel="canonical" href={canonicalURL} />

            {/* Open Graph / Facebook tags */}
            <meta property="og:type" content={type} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonicalURL} />
            <meta property="og:image" content={siteImage} />

            {/* Twitter tags */}
            <meta name="twitter:creator" content={name} />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={siteImage} />

            {schema && <script type="application/ld+json">{JSON.stringify(schema)}</script>}
        </Helmet>
    );
}

SEO.defaultProps = {
    title: "",
    description: "Master Morse Code with Keyer's Journey. Features Koch method training, realistic QSO simulation, and interactive history timeline.",
    name: "Keyer's Journey",
    type: "website",
    image: "https://www.keyersjourney.com/icon.png"
};
